 
import React from 'react';
import { Box, FlexControlledForm } from '@common-fe/common-fe';

import { ServiceCategoryTypes } from '@/modules/employer/types/ServiceCategories.types';
import { useCopayFields } from '@/modules/ExpressSetup/ExpressSetupWizard/PlansWizard/Copays/hooks/useCopayFields.tsx';

import { useCopayActions } from '../hooks/useCopayActions';

interface Props {
  serviceCategories?: ServiceCategoryTypes[],
}

const CopaysForm: React.FC<Props> = ({
  serviceCategories,
}) => {
  const {
    copayState,
    showErrors,
    handleAddCopay,
    handleRemoveCopay,
    handleUpdateCopay,
  } = useCopayActions();

  const fields = useCopayFields({
    copaysDefault: copayState.copays || [],
    showErrors: showErrors,
    onAddCopay: handleAddCopay,
    onRemoveCopay: handleRemoveCopay,
    onUpdateCopayState: handleUpdateCopay,
    renewalMode: true,
    serviceCategories: serviceCategories,
  });

  return (
    <Box
      data-testid="copays-change-form"
      background="canvas"
      round="container1Round"
    >
      <FlexControlledForm
        fields={fields}
        editMode
        isModalType
      />
    </Box>
  );
};

export default CopaysForm;
